import { render, staticRenderFns } from "./FNewsInformation.vue?vue&type=template&id=c5226500&scoped=true&"
import script from "./FNewsInformation.vue?vue&type=script&lang=js&"
export * from "./FNewsInformation.vue?vue&type=script&lang=js&"
import style0 from "./FNewsInformation.vue?vue&type=style&index=0&id=c5226500&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5226500",
  null
  
)

export default component.exports